import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { SpinnerOverlayService } from './spinner-overlay.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

export const GENERIC_SPINNER_TITLE = 'Processing... please wait';

@Component({
  selector: 'm-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrls: ['./spinner-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class SpinnerOverlayComponent {
  private spinnerService = inject(SpinnerOverlayService);

  spinningEvents$ = toObservable(this.spinnerService.spinningEvents);

  title = this.spinningEvents$.pipe(
    map(spinningEvent => {
      this.hidden = !spinningEvent.spinning;
      return spinningEvent.title || GENERIC_SPINNER_TITLE;
    }),
    startWith(GENERIC_SPINNER_TITLE)
  );

  @HostBinding('class.hidden') hidden = true;
}
